import { render } from "./ActivitiesPage.vue?vue&type=template&id=e32b4040&ts=true"
import script from "./ActivitiesPage.ts?vue&type=script&lang=ts"
export * from "./ActivitiesPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__